const type = 'SET_SERVICE_REQUESTS_LOADING';

const setServiceRequestsLoading = (data) => ({
  data,
  type,
});

export { type };
export default setServiceRequestsLoading;
